<template>
      <div class="settings-layout details-layout">
        <form>
            <div class="form-section">
                <div class="registration-page-title">Create user</div>
            </div>
            <div class="form-section">
                <div class="form-group w-80">
                    <label>BUSINESS NAME</label>
                    <div class="input-group-cover">
                        <input type="text" @input="submit" v-model="storeName" placeholder="Business name" name="storeName" id="storeName" @blur="v$.storeName.$touch()">
                    </div>
                    <FormError :validationStatus="v$.storeName"/>
                    <span v-show="v$.storeName.validStoreName.$pending && !v$.storeName.minLength.$invalid">Checking Store Name...</span>
                    <p v-if="v$.storeName.validStoreName.$invalid && !v$.storeName.minLength.$invalid && !v$.storeName.validStoreName.$pending && v$.storeName.$dirty && v$.storeName.$model != ''" class="help-block">{{ this.userNameMsg }}</p>
                    <p v-if="!v$.storeName.validStoreName.$invalid && !v$.storeName.minLength.$invalid" class="">Store Name is valid</p>
                </div>

                <div class="form-group w-80">
                    <label>CREATE USERNAME</label>
                    <div class="input-group-cover">
                       <input type="text" autocomplete="off" @input="submit" v-model="userName" placeholder="Username" name="username" id="username" :disabled="userCreated" @blur="v$.userName.$touch()">
                    </div>
                    <FormError :validationStatus="v$.userName"/>
                    <span v-show="v$.userName.validUserName.$pending && !v$.userName.minLength.$invalid">Checking User Name...</span>
                    <p v-if="!v$.userName.validUserName.$invalid && !v$.userName.minLength.$invalid" class="">User Name is valid</p>
                    <div id="username-error-wrapper"></div>
                </div>
                        
                <div class="form-group w-80">
                    <label>PHONE</label>
                    <vue-tel-input name="mobile" id="mobile" 
                        :value="mobile" 
                        @input="onInput" 
                        @keyup="submit" 
                        @keypress="validateNumber" 
                        v-bind="bindProps" 
                        @blur="v$.mobile.$touch()"                        
                        :defaultCountry="userCountryCode"
                        :disabled="userCreated">
                    </vue-tel-input>
                    <p v-if="!validPhone" class="help-block">
                        Please input a complete phone number
                    </p>
                </div>

                <div class="form-group w-80">
                    <label>EMAIL</label>
                    <div class="input-group-cover">
                        <input type="email" @input="submit" placeholder="Email" name="email" id="email" v-model="email" :disabled="userCreated" @blur="v$.email.$touch()">
                    </div>
                    
                    <span v-show="v$.email.$invalid && v$.email.validEmail.$pending">Checking Email...</span>
                    <p v-if="v$.email.validEmail.$invalid && !v$.email.validEmail.$pending && v$.email.$model != ''" class="help-block">
                        Invalid email or this email has already been taken
                    </p>
                    <p v-else><FormError :validationStatus="v$.email"/></p>
                    <p v-if="!v$.email.$invalid && !v$.email.validEmail.$invalid" class="">Email is valid</p>
                </div>

                <div class="form-group w-80" style="display: none;">
                    <label>EMAIL</label>
                    <div class="input-group-cover">
                        <input type="email" @input="submit" placeholder="Email" name="email111" id="email111" autocomplete="new-password">
                    </div>
                </div>

                <div class="form-group w-80">
                    <label for="">CREATE PASSWORD</label>
                    <input class="placeholder-no-fix required password-with-eye" @input="submit" type="password"
                     autocomplete="new-password" placeholder="Password" id="password" name="password" v-model="password"
                      aria-describedby="inputGroupPrepend" @blur="v$.password.$touch()"/>
                        <button type="button" class="button button-password-eye" @click="toggleShowPassword">
                            <span class="icon is-small is-right" style="color: black;">
                                <i class="fas" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                            </span>
                        </button>
                    <FormError :validationStatus="v$.password"/>
                    <p v-if="v$.password.validPassword.$invalid && v$.password.$model != ''" class="help-block">Invalid password</p>
                    <p v-if="!v$.password.validPassword.$invalid">Password is valid</p>

                    <div id="pswd_info" class="hide">
                        <ul>
                            <li id="letter" class="invalid"><i class="fas fa-times mr-2"></i> At least <strong>one letter</strong></li>
                            <li id="capital" class="invalid"><i class="fas fa-times mr-2"></i> At least <strong>one capital letter</strong></li>
                            <li id="number" class="invalid"> <i class="fas fa-times mr-2"></i>At least <strong>one number</strong></li>
                            <li id="length" class="invalid"> <i class="fas fa-times mr-2"></i>Be at least <strong>12 characters</strong></li>
                            <li id="space" class="invalid"><i class="fas fa-times mr-2"></i>  use a <strong>[~,!,@,#,$,%,^,&,*,-,=,.,;,']</strong></li>
                        </ul>
                    </div>
                </div>
                
                <div class="form-group w-80">
                    <label for="">CONFIRM PASSWORD</label>
                    <input class="placeholder-no-fix required" @input="submit" type="password" autocomplete="off" placeholder="Confirm Password" name="password_confirmation" id="password_confirmation" aria-describedby="inputGroupPrepend"  v-model="confirmPassword" @blur="v$.confirmPassword.$touch()" />
                    <p v-if="v$.confirmPassword.validConfirmPassword.$invalid && v$.confirmPassword.$model != ''" class="help-block">The value must be equal to password</p>
                    <FormError :validationStatus="v$.confirmPassword"/>
                </div> 

                <div class="form-group w-80">
                    <label>LITT MANAGER</label>
                    <div class="input-group-cover">
                        <input type="text" @input="submit" placeholder="Referred by" name="littManager" id="littManager"  v-model="manager" @blur="v$.manager.$touch()">
                    </div>
                    <FormError :validationStatus="v$.manager"/>
                </div>

                <div class="form-group w-80">
                    <label>LITTLAND REFERRER</label>
                    <div class="input-group-cover">
                        <input type="text" @input="submit" placeholder="Username or email" name="littlandReferrer" id="littlandReferrer" v-model="landReferrer" :disabled="initReferrer" @blur="v$.landReferrer.$touch()">
                    </div>
                    <FormError :validationStatus="v$.landReferrer"/>
                </div>             
            </div>
        </form>
    </div>
</template>

<script>
import FormError from './../../FormError.vue';
import { required, email, minLength, helpers } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import { useCookies } from "vue3-cookies";
import $ from 'jquery';
import moment from 'moment';

const { cookies } = useCookies();
const { withAsync } = helpers

const validStoreName = async (value) => {
    if (value === "") return false;
    if(value.length >= 2){
        const data = {'storeName': value};
        const response =  await axios.post('check-name', data)
        .catch(function (error) {
            console.log(error);
            return false;
        })
        return (response.data.status === 'true');
    }
    return false;
};

const validUserName = async (value) => {
    if (value === "") return false;
    let valid = false;

    if(value.length >= 3){
        const headers = { 'Content-Type': 'application/json' }

        await axios.post('../api/v2/users/check-username', 
            JSON.stringify({
                api: "check-username", 
                data: {
                    "username": value
                }
            }), { headers: headers }
        )
        .then((response) => {
            valid = (response.data.status == 'success');
            if (!valid) {
                $("#username-error-wrapper").html('<p id="username-error" class="help-block"></p>');
                $("#username-error").text(response.data.message);
            } else {
                valid = true;
                $("#username-error").remove();
            }
        })
        .catch(function (error) {
            console.log(error);
            return false;
        })
        return valid;
    }
    return false;
};

const validEmail = async (value) => {
    if (value === "") return false;
    const data = {'email': value};
    const response =  await axios.post('check-email', data)
    .catch(function (error) {
        console.log(error);
        return false;
    })

    return (response.data.status === 'true');
};

const validPassword = (value) => {
    return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$/.test(value)
}

const validConfirmPassword = (value) => {
    return value == $('input[name=password]').val();
}

export default {
    name: "CreateUser",
    components: {VueTelInput, FormError},
    props: ['formData', 'planMonthlyFee', 'yearlyPlan', 'littManager', 'littlandReferrer', 'userCreated', 'merchant', 'subscriptionplans'],
    setup(){
        return { v$: useVuelidate() }
    },
    emits: ["update", "next"],
    data(){
        return{
            userCountryCode: this.formData.countryCode,
            showPassword: false,
            storeName: "",
            userName: "",
            userNameMsg: "",
            email: "",
            mobile: "",
            validPhone: false,
            password: "",
            confirmPassword: "",
            initReferrer: this.littlandReferrer ? this.littlandReferrer : cookies.get('littland_referrer'),
            manager: this.littManager,
            landReferrer: this.littlandReferrer ? this.littlandReferrer : cookies.get('littland_referrer'),
            bindProps: {
                onlyCountries: ["AU", "US", "ID"],
                mode: 'international'
            },
            plans: JSON.parse(this.subscriptionplans),
            planCycle: this.formData.yearlyPlan ? 'Yearly' : 'Monthly',
            currPlan: "",
            originalPlanStartDate: "",
            originalPlanEndDate: "",
            originalPlanStartDateDisplay: "",
            defaultFreeTrial: 0
        }
    },
    methods:{
        moment: function () {
            return moment();
        },
        setDates() {
            this.currPlan = this.plans.find((element) => (element.billing_cycle === this.planCycle && element.country.code === this.userCountryCode));
            this.planFee = this.currPlan.price;
            this.joiningFee = this.currPlan.joining_fee;
            this.originalPlanFee = this.currPlan.price;
            this.originalJoiningFee = this.currPlan.joining_fee;

            this.originalPlanStartDateDisplay = moment().add(this.currPlan.free_trial_duration, 'M').format('D MMM YYYY');
            this.originalPlanStartDate = moment().add(this.currPlan.free_trial_duration, 'M').format('YYYY-MM-DD 00:00:00');
            this.originalPlanEndDate = moment(this.originalPlanStartDate, 'YYYY-MM-DD 00:00:00').add(1, this.currPlan.billing_cycle == 'Yearly' ? 'y' : 'M').format('YYYY-MM-DD 00:00:00');

            this.submit();
        },
        submit(){
            this.$emit('update', {
                data:{
                    storeName: this.storeName,
                    userName: this.userName,
                    email: this.email,
                    mobile: $('input[name=telephone]').val(),
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                    littManager: this.manager,
                    littlandReferrer: this.landReferrer,
                    countryCode: this.userCountryCode,
                    planFee: this.planFee,
                    joiningFee: this.joiningFee,
                    selectedPlan: this.currPlan,
                    selectedPlanId: this.currPlan.id,
                    originalPlanFee: this.originalPlanFee,
                    originalJoiningFee: this.originalJoiningFee,
                    originalPlanStartDateDisplay: this.originalPlanStartDateDisplay,
                    originalPlanStartDate: this.originalPlanStartDate,
                    originalPlanEndDate: this.originalPlanEndDate,
                    defaultFreeTrial: this.currPlan.free_trial_duration
                },

                valid: !this.v$.$invalid && this.validPhone
            })
        },
        onInput(mobile, phoneObject, input) {

            this.validPhone = phoneObject.valid;

            if (phoneObject?.formatted) {
                this.mobile = phoneObject.formatted;
            }
        },
        validateNumber: (event) => { 
            let keyCode = event.keyCode; 
            if (keyCode < 48 || keyCode > 57) {  
                event.preventDefault(); 
            } 
        },
        checkPassword(){
            $('input[name=password]').keyup(function() { 
                var pswd = $(this).val();
                
                //validate the length
                if ( pswd.length < 12 ) {
                    $('#length').removeClass('valid').addClass('invalid').find('i').removeClass('fa-check').addClass('fa-times');
                } else {
                    $('#length').removeClass('invalid').addClass('valid').find('i').removeClass('fa-times').addClass('fa-check');
                }
                
                //validate letter
                if ( pswd.match(/[A-z]/) ) {
                    $('#letter').removeClass('invalid').addClass('valid').find('i').removeClass('fa-times').addClass('fa-check');
                } else {
                    $('#letter').removeClass('valid').addClass('invalid').find('i').removeClass('fa-check').addClass('fa-times');
                }
        
                //validate capital letter
                if ( pswd.match(/[A-Z]/) ) {
                    $('#capital').removeClass('invalid').addClass('valid').find('i').removeClass('fa-times').addClass('fa-check');
                } else {
                    $('#capital').removeClass('valid').addClass('invalid').find('i').removeClass('fa-check').addClass('fa-times');
                }
        
                //validate number
                if ( pswd.match(/\d/) ) {
                    $('#number').removeClass('invalid').addClass('valid').find('i').removeClass('fa-times').addClass('fa-check');
                } else {
                    $('#number').removeClass('valid').addClass('invalid').find('i').removeClass('fa-check').addClass('fa-times');
                }
                
                //validate space
                if ( pswd.match(/[^a-zA-Z0-9\-\/]/) ) {
                    $('#space').removeClass('invalid').addClass('valid').find('i').removeClass('fa-times').addClass('fa-check');
                } else {
                    $('#space').removeClass('valid').addClass('invalid').find('i').removeClass('fa-check').addClass('fa-times');
                }
                
            }).focus(function() {
                $('#pswd_info').removeClass('hide');
                $('#pswd_info').css("display", "block");
            }).blur(function() {
                $('#pswd_info').hide();
            });
        },
        toggleShowPassword() {
            this.showPassword = !this.showPassword;
            if (this.showPassword) {
                $("#password").prop("type", "text");
            } else {
                $("#password").prop("type", "password");
            }
        },
        syncDates(){
            this.currPlan = this.plans.find((element) => (element.billing_cycle === this.planCycle && element.country.code === this.userCountryCode));
            this.setDates();
        }
    },
    mounted() {
        this.validPhone = true;
        window.scrollTo(0,0);
        this.checkPassword();

        if (this.initReferrer && !cookies.get('littland_referrer')) {
            const d = new Date();
            d.setTime(d.getTime() + (365 * 24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = "littland_referrer=" + this.initReferrer + ";" + expires + ";path=/";
        }

        $('input[name=telephone]').bind("paste",function(){return false;});

        this.syncDates();

    },
    beforeDestroy() {
        this.syncDates();
    },
    validations:{
        storeName: {required, minLength: minLength(2), validStoreName: withAsync(validStoreName)},
        userName: {required, minLength: minLength(2), validUserName: withAsync(validUserName)},
        email: {required, validEmail: withAsync(validEmail)},
        mobile: {required},
        password: {required, minLength: minLength(12), validPassword: validPassword},
        confirmPassword: {required, validConfirmPassword: validConfirmPassword},
        manager: {minLength: minLength(2)},
        landReferrer: {minLength: minLength(5)}
    }
}

</script>
